"use client"

import { loginWithSocialAuthCode } from "@/lib/data/customer"
import { redirect, useRouter } from "next/navigation"
import useLocaleRouter from "@/hooks/useLocaleRouter"
import { useEffect, useState } from "react"
import { useTranslate } from "@tolgee/react"
import { useAppContext } from "@/lib/context/app-context"
import { umamiTrackEvent } from "@/lib/utils/umami"
import ErrorMessage from "../ErrorMessage/ErrorMessage"
import Spinner from "@/icons/spinner"

type CallbackParams = {
    provider: string,
}

export const SocialLoginCallbackProcess = ({ provider }: CallbackParams) => {
    const [isLoading, setIsLoading] = useState(true)
    let [error, setError] = useState("")
    const { t } = useTranslate()
    const localeRouter = useLocaleRouter(useRouter())
    let appContext = useAppContext()

    useEffect(() => {
        const tryLogin = async () => {
            const queryParams = Object.fromEntries(new URLSearchParams(window.location.search).entries())
            const rs = await loginWithSocialAuthCode(provider, queryParams)
            if (typeof rs === "string") {
                console.log("-----------query , err: ", queryParams, rs)
                setError(rs)
                return;
            }
            setIsLoading(false)
            let userId = rs.jwtInfo?.actor_id;
            appContext.user = {
                id: userId
            } as any
            appContext.analytics?.("login", {
                method: "Google"
            })
            umamiTrackEvent("login", appContext, {
                method: "Google"
            })
            if (rs.register) {
                appContext.analytics?.("sign_up", {
                    method: "Google"
                })
                umamiTrackEvent("sign_up", appContext, {
                    method: "Google"
                })
            }
            return localeRouter.replace('/user')
        }
        let from = window.localStorage.getItem("from_login")
        if (from) {
            window.localStorage.removeItem("from_login");
            window.location.href = from + window.location.href.toString().replace(window.location.origin, "")
        } else {
            tryLogin()
        }
    }, [])

    return (
        <div className="w-screen h-screen flex justify-center items-center">
            {error && <ErrorMessage error={error} />}
            {!error && <Spinner />}
            {/* {!error && isLoading && <span>{t("common.loading")}</span>} */}
            {/* {!error && (isLoading || <span>{t("social_login_callback.redirecting")}</span>)} */}
        </div>
    )

}
